
import React from 'react';
import { Box, Typography } from '@mui/material';

type MessageProps = {
  message: any;
};

const MessageImage: React.FC<MessageProps> = ({ message }) => {
  try {
    const content = message?.content || {};
    const headerText = content?.header?.text || '';
    const footerText = content?.footer?.text || '';
    const bodyText = content?.body?.text || '';
    const imageUrl =
      content?.media?.s3_object?.url ||
      content?.media?.url ||
      content?.previewUrl ||
      content?.url;

    return (
      <Box>
        {/* Header */}
        {headerText && (
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {headerText}
          </Typography>
        )}

        {/* Image */}
        {imageUrl ? (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt="Message"
              style={{
                width: '100%',
                maxHeight: '300px',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
          </a>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No image available
          </Typography>
        )}

        {/* Caption Text */}
        {bodyText && (
          <Typography variant="body2" mt={1} sx={{ whiteSpace: 'pre-line' }}>
            {bodyText}
          </Typography>
        )}

        {/* Footer */}
        {footerText && (
          <Typography variant="caption" color="text.secondary" display="block" mt={1}>
            {footerText}
          </Typography>
        )}
      </Box>
    );
  } catch (error) {
    return <Typography color="error">Error displaying image message</Typography>;
  }
};

export default MessageImage;
